/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const ZodiacCancer = createLucideIcon("zodiac-cancer", [
  ["path", { d: "M21 14.5A9 6.5 0 0 1 5.5 19", key: "1xj2o6" }],
  ["path", { d: "M3 9.5A9 6.5 0 0 1 18.5 5", key: "1gln3t" }],
  ["circle", { cx: "17.5", cy: "14.5", r: "3.5", key: "1ccu1t" }],
  ["circle", { cx: "6.5", cy: "9.5", r: "3.5", key: "x5tc2d" }]
]);

export { ZodiacCancer as default };
//# sourceMappingURL=zodiac-cancer.js.map
